document.addEventListener('DOMContentLoaded', function() {
  const faqSections = document.querySelectorAll('.faq-section');

  faqSections.forEach(section => {
    const buttons = section.querySelectorAll('.faq-section__question');

    buttons.forEach(button => {
      button.addEventListener('click', function() {
        const item = this.closest('.faq-section__item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        // Close other open items
        section.querySelectorAll('.faq-section__item.is-active').forEach(activeItem => {
          if (activeItem !== item) {
            activeItem.classList.remove('is-active');
            activeItem.querySelector('.faq-section__question').setAttribute('aria-expanded', 'false');
          }
        });

        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          item.classList.remove('is-active');
        } else {
          this.setAttribute('aria-expanded', 'true');
          item.classList.add('is-active');
        }
      });
    });
  });
});
